import {Injectable} from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {environment} from '../../../../src/environments/environment';
import {map} from 'rxjs/operators';
import {ConfigAuth, OAUTH_CLIENTS} from './config.interface';
import {BehaviorSubject} from 'rxjs';

interface OAuth {
  [k: string]: string;
}

@Injectable()
export class ConfigApiService {
  protected baseUrl = environment.backEndUrlPrefix + '/';


  public oauth2Clients: BehaviorSubject<OAuth> = new BehaviorSubject<OAuth>({});
  public supersetUrl = '';
  private _oauth2Clients: OAuth = {};

  constructor(protected http: HttpClient) {
  }

  getAuth() {
    return this.http.get<ConfigAuth>(this.baseUrl + 'config/auth ').pipe(map((res) => {
      res.oauth2Clients.forEach(item => {
        this._oauth2Clients[item.clientId] = item.url;

      });
      this.supersetUrl =  this._oauth2Clients[OAUTH_CLIENTS.superset];
      this.oauth2Clients.next(this._oauth2Clients);
    }));
  }

  getVersion()  {
    return this.http.get(this.baseUrl + 'version', {responseType: 'text'});
  }

}
